import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersist({
  key: process.env.VUE_APP_PROJECT_KEY,
  storage: window.localStorage,
  modules: ["accessToken", "refreshToken", "user", "theme"],
});

export default new Vuex.Store({
  state: {
    accessToken: "",
    refreshToken: "",
    user: null,
    wallet: null,
    theme: "light",
  },

  getters: {
    authenticated: ({ accessToken, refreshToken, user }) =>
      !!accessToken && !!refreshToken && !!user,
    accessToken: ({ accessToken }) => accessToken,
    refreshToken: ({ refreshToken }) => refreshToken,
    user: ({ user }) => user,
    wallet: ({ wallet }) => wallet,
    theme: ({ theme }) => theme,
  },

  mutations: {
    SET_ACCESS_TOKEN(state, payload) {
      state.accessToken = payload;
    },

    SET_REFRESH_TOKEN(state, payload) {
      state.refreshToken = payload;
    },

    SET_USER(state, payload) {
      state.user = payload;
    },

    SET_WALLET(state, payload) {
      state.wallet = payload;
    },

    SET_THEME(state, payload) {
      state.theme = payload;
    },
  },

  actions: {
    setAccessToken({ commit }, payload) {
      commit("SET_ACCESS_TOKEN", payload);
    },

    setRefreshToken({ commit }, payload) {
      commit("SET_REFRESH_TOKEN", payload);
    },

    setUser({ commit }, payload) {
      commit("SET_USER", payload);
    },

    setWallet({ commit }, payload) {
      commit("SET_WALLET", payload);
    },

    setTheme({ commit }, payload) {
      commit("SET_THEME", payload);
    },

    setSignIn({ dispatch }, payload) {
      dispatch("setAccessToken", payload.accessToken);
      dispatch("setRefreshToken", payload.refreshToken);
      dispatch("setUser", payload.user);
    },

    setSignOut({ dispatch }) {
      dispatch("setAccessToken", "");
      dispatch("setRefreshToken", "");
      dispatch("setUser", null);
    },
  },

  modules: {},

  plugins: [vuexLocal.plugin],
});
